<template>
  <ion-page>
    <ion-header>
      <div class="navbar">
        <img class="nav-icon" :src="getBrandImageUrl('xiaoyu.png')" alt="" @click="onClose" />
        {{ pageTitle }}
      </div>
      <!-- <ion-toolbar class="topbar">
        <ion-buttons slot="start">
          <ion-icon :icon="chevronBackOutline" @click="onClose" fill="clear" color="Medium"></ion-icon>
        </ion-buttons>
        <ion-title>{{ pageTitle }}</ion-title>
      </ion-toolbar> -->
    </ion-header>
    <ion-content
      :style="{
        '--ion-content-bg': `url(${brandImages.classrecod_bg}) center center /cover`,
      }"
    >
      <ion-refresher slot="fixed" @ionRefresh="doRefresh($event)">
        <ion-refresher-content
          pulling-text="Pull to refresh"
          refreshing-spinner="circles"
          refreshing-text="Refreshing..."
        >
        </ion-refresher-content>
      </ion-refresher>
      <div style="height: 22px"></div>
      <!-- <ion-searchbar placeholder="请输入章节名称"
                     @ionChange="searchReadingArticle">
      </ion-searchbar> -->
      <div
        v-for="(item, index) in dataList"
        :key="index"
        class="content-list"
        @click="openGrammarPage(item)"
      >
        <div style="display: flex; align-items: center; flex: 1">
          <img class="pic" :src="getBrandImageUrl('grammar1.png')" alt="" />
          <div style="color: #262626; font-size: 13px">
            {{ item.chapterName }}
          </div>
        </div>
        <!--        <img v-if="item.lock == 1" class="pic2" :src="getBrandImageUrl('grammar3.png')" alt="" />-->
        <!--        <img v-else class="pic2" :src="getBrandImageUrl('grammar2.png')" alt="" />-->
      </div>

      <!-- <ion-list class="is-list-condensed">
        <ion-item :class="item.lock==1?'locked':''" v-for="(item, index) in dataList" :key="index" detail @click="openGrammarPage(item)">
          <div slot="start" class="ion-no-margin">
            <ion-icon :icon="documentTextOutline"></ion-icon>
          </div>
          <ion-label>
            <h2 style="width: 100%;">{{ item.chapter }} {{ item.chapterName }}</h2>
          </ion-label>
          <ion-buttons slot="end">
            <img v-if="item.lock==1" style="width: 1.5rem;height:1.5rem;" :src="brandImages.readingLocked"/>
            <img v-if="item.lock==2" style="width: 1.5rem;height:1.5rem;" :src="brandImages.readingUnlock"/>
            <span style="width: 1rem;"></span>
          </ion-buttons>
        </ion-item>
      </ion-list> -->
      <ion-infinite-scroll
        id="infinite-scroll"
        threshold="100px"
        :disabled="isDisabled"
        @ionInfinite="loadData($event)"
      >
        <ion-infinite-scroll-content loading-spinner="bubbles" loading-text="数据加载中...">
        </ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </ion-content>
  </ion-page>
</template>
<script>
import {
  IonPage,
  IonHeader,
  IonContent,
  IonRefresher,
  IonRefresherContent,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  modalController,
} from "@ionic/vue";

import { documentTextOutline, filmOutline, chevronBackOutline } from "ionicons/icons";
import GrammarPage from "@/views/grammar/GrammarPage";
import { BRAND_IMAGES, getBrandImageUrl } from "@/js/brandImages.ts";
import GrammarTemplate from "@/views/grammar/GrammarTemplate.vue";

export default {
  name: "GrammarChapter",
  components: {
    IonPage,
    IonHeader,
    IonContent,
    IonRefresher,
    IonRefresherContent,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
  },
  setup() {
    return {
      documentTextOutline,
      filmOutline,
      chevronBackOutline,
    };
  },
  data() {
    return {
      dataList: [],
      isDisabled: false,
      pageTitle: undefined,
      queryForm: {
        pageNum: 1,
        pageSize: 50,
        courseId: undefined,
        studentId: undefined,
      },
      brandImages: BRAND_IMAGES,
    };
  },

  mounted() {
    this.userinfo = this.store.getUser();
    this.queryGrammarChapter();
  },
  methods: {
    getBrandImageUrl,
    //查询阅读理解文章
    queryGrammarChapter() {
      const appointment = this.store.getAppointment();
      this.queryForm.courseId = appointment.courseId;
      this.queryForm.studentId = appointment.studentId;
      this.ajax.post("/grammar/queryGrammarChapterForApp", this.queryForm).then((res) => {
        if (res.data.success) {
          const page = res.data.page;
          this.pageTitle = res.data.title;
          if (page.list) {
            page.list.forEach((obj) => {
              this.dataList.push(obj);
            });
            if (appointment.classification === 4) {
              // classification 4 体验资料
              this.dataList = this.dataList.slice(0, 2);
            }
          }
          this.queryForm.pageNum++;
        }
      });
    },

    searchReadingArticle(e) {
      this.queryForm.title = e.detail.value;
      this.queryForm.pageNum = 1;
      if (this.queryForm.title) {
        this.queryForm.title = this.queryForm.title.trim();
        if ("" == this.queryForm.title) {
          this.queryForm.title = undefined;
        }
      }

      this.dataList = [];
      this.queryGrammarChapter();
    },

    async openGrammarPage(item) {
      // if (item.lock == 1) {
      //   return;
      // }
      if (item.courseId === 629 || item.courseId === 394 || item.courseId === 2054) {
        const modal = await modalController.create({
          component: GrammarPage,
          componentProps: {
            courseId: item.courseId,
            chapterId: item.chapterId,
            chapter: item.chapter,
          },
          cssClass: "modal_controller_class",
        });
        await modal.present();
        const { data } = await modal.onDidDismiss();
        if ("FINISHED" === data) {
          this.doRefresh();
        }
      } else {
        await this.openTemplateDialog(item);
      }
    },
    async openTemplateDialog(item) {
      const modal = await modalController.create({
        component: GrammarTemplate,
        componentProps: {
          courseId: item.courseId,
          chapterId: item.chapterId,
          chapter: item.chapter,
        },
        cssClass: "modal_controller_class",
      });
      await modal.present();
      const { data } = await modal.onDidDismiss();
      if ("FINISHED" === data) {
        this.doRefresh();
      }
    },

    doRefresh(RefreshAnimationEvent) {
      if (RefreshAnimationEvent) {
        RefreshAnimationEvent.target.complete();
      }
      this.queryForm.pageNum = 1;
      this.dataList = [];
      this.queryGrammarChapter();
    },

    loadData(ev) {
      this.queryGrammarChapter();
      ev.target.complete();
    },
  },
};
</script>
<style scoped>
.is-list-condensed {
  background: none;
}

.is-list-condensed ion-item {
  border-top: 1px solid #fff;
  border-bottom: 1px solid #ccc;
  --inner-border-width: 0px;
  --border-width: 0;
  user-select: none;
  opacity: 0.8;
}

ion-content {
  --background: var(--ion-content-bg);
}

ion-list-header {
  background: #fff;
}

ion-label h2 {
  color: #000;
  font-size: 1rem;
  width: 30vw;
}

ion-label p {
  color: #555;
  font-size: 0.6rem;
}

ion-icon {
  font-size: 2rem;
  margin-right: 3vw;
}

.is-list-vertical-buttons ion-icon {
  color: #ccc;
}

.locked {
  color: #9d9fa6;
}

.locked * {
  color: #9d9fa6 !important;
}
/* new ui  */
.navbar {
  height: 44px;
  line-height: 44px;
  text-align: center;
  position: relative;
}
.nav-icon {
  width: 24px;
  height: 24px;
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translate(0, -50%);
}
ion-header::after {
  display: none;
}
ion-header {
  background: #fff;
}
ion-content {
  --background: #fff;
}
.content-list {
  height: 52px;
  width: 92vw;
  margin: 0 auto 10px;
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
  background: #f8f8f8;
}
.pic {
  width: 15px;
  height: 15px;
  display: block;
  margin-right: 6px;
}
.pic2 {
  width: 18px;
  height: 18px;
}
</style>
